<template>
  <Admin style="background: white">
    <v-main v-if="!isProductListLoading" class="wrapper">
      <v-container v-if="!selectedCompanyProductList?.isNsThaiSmartTax" fluid>
        You are not allowed for this feature, Please contact Sales
        <a href="tel:026637895" target="_blank"
        ><b><u>026637895</u></b></a
        >
      </v-container>
      <v-container v-else fluid>
        <div class="mb-1 tw-text-xl tw-font-bold tw-mb-3">
          แบบแสดงรายการภาษีมูลค่าเพิ่ม
        </div>
        <v-divider/>
        <v-dialog v-model="pdfDialog">
          <div>
            <iframe :src="pdfSrc" class="iframe"></iframe>
          </div>
        </v-dialog>
        <v-card class="pa-4">
          <v-row>
            <v-col class="d-flex align-center" cols="5">
              <div >ยื่นแบบแสดงรายการโดย:</div>
            </v-col>
            <v-col cols="2">
              <v-select
   :menu-props="{ bottom: true, offsetY: true }"
                  v-model="filterFetchData.submitType"
                  :items="submitTypeList"
                  class="input-boder"
                  dense
                  hide-details
                  label="ยื่นแบบ"
                  outlined
              ></v-select>
            </v-col>
          </v-row>

          <!-- {{ taxWHBranch.branch }} -->

          <v-row style="margin-top: -10px">
            <v-col class="d-flex align-center" cols="5">
              <div >สาขากิจการ:</div>
            </v-col>
            <v-col cols="2">
              <v-select
   :menu-props="{ bottom: true, offsetY: true }"
                  v-model="filterFetchData.selectBranchId"
                  :disabled="isSubmitAll"
                  :items="taxWHBranch.branch"
                  class="input-boder"
                  dense
                  hide-details
                  item-disabled="disable"
                  item-text="code"
                  item-value="code"
                  label="เลือกสาขากิจการ"
                  outlined
              ></v-select>
            </v-col>
          </v-row>

          <v-row style="margin-top: -10px">
            <v-col class="d-flex align-center" cols="5">
              <div >สถานะการยื่นแบบแสดงรายการ: </div>
            </v-col>
            <v-col cols="2">
              <v-select
                  :menu-props="{ bottom: true, offsetY: true }"
                  v-model="filterFetchData.submitStatus"
                  :items="submitStatusList"
                  class="input-boder"
                  dense
                  hide-details
                  label="สถานะการยื่น"
                  outlined
              ></v-select>
            </v-col>
          </v-row>

          <v-row style="margin-top: -40px">
            <v-col cols="5">
              <v-checkbox
                  v-model="filterFetchData.additionalFilingStatus"
                  class="input-boder"
                  dense
                  hide-details
                  style="margin-left: 0px"
                  value="within_time"
              >
              <template v-slot:label>
                  <span class="tw-text-black" style="margin-top: 4px">ภายในกำหนดเวลา</span>
                  </template>
            </v-checkbox>
              <v-checkbox
                  v-model="filterFetchData.additionalFilingStatus"
                  dense
                  hide-details
                  style="margin-left: 0px; margin-top: -5px"
                  value="late_filing"
              >
              <template v-slot:label>
                  <span class="tw-text-black" style="margin-top: 4px">เกินกำหนดเวลา</span>
                  </template>
            </v-checkbox>
            </v-col>
          </v-row>

          <v-row style="margin-top: -20px">
            <v-col class="d-flex align-center" cols="5">
              <div >เดือน-ปีที่ยื่นภาษี:</div>
            </v-col>
            <v-col cols="2">
              <v-select
   :menu-props="{ bottom: true, offsetY: true }"
                  ref="selectMenu"
                  v-model="filterFetchData.selectedPeriod"
                  :items="hierarchicalPeriods"
                  dense
                  hide-details
                  item-text="name"
                  item-value="name"
                  label="เลือกเดือนที่ยื่นภาษี"
                  outlined
                  return-object
              >
                <template v-slot:item="{ item, props }">
                  <v-list-item
                      :class="getColorClass(item)"
                      :disabled="item.level === 0 || item.level === 1"
                      v-bind="props"
                      @click="handleTimePeriodSelectionAndCloseMenu(item)"
                  >
                    <v-list-item-title
                        :style="{
                        fontWeight: item.level === 0 ? 'bold' : 'normal',
                      }"
                    >
                      <span :style="{ 
                paddingLeft: `${item.level * 20}px`, 
                opacity: 1,
                color: item.level === 0 ? '#1976D2' : 'black',
                fontWeight: item.level === 0 ? 'bold' : 'normal'
              }">{{
                          item.name
                        }}</span>
                    </v-list-item-title>
                  </v-list-item>
                </template>
              </v-select>
            </v-col>
          </v-row>

          <v-row style="margin-top: 10px">
            <v-col cols="5" class="tw-pr-0 tw-pt-0">
              <div  v-if="logsList.length > 0">
                <h1 class="tw-pb-2 tw-pt-4">ประวัติ</h1>
                <div class="tw-grid tw-grid-cols-10 tw-gap-2">
                  <div class="tw-w-"></div>
                <v-chip
                    v-for="log in logsList"
                    :key="log.index"
                    label
                    link
                    outlined
                    @click="openLogDetail(log)"
                    class="tw-p-0 t w-flex tw-justify-center"
                >
                  <span class="tw-text-center tw-w-full">{{ log.index}}</span>
                </v-chip>
                </div>
              </div>
            </v-col>
            <v-col cols="2">
              <v-btn
                  :disabled="isLoading"
                  :loading="isLoading"
                  block
                  class="white--text"
                  color="primary"
                  style="font-size: 14px"
                  @click="fetchTaxReport"
              >
                <template v-slot:default>
                  <v-icon left>mdi-download</v-icon>
                  ดึงข้อมูล
                </template>
              </v-btn>
            </v-col>
          </v-row>


          <v-dialog v-model="logDialog" max-width="480">
                    <v-card>
                      <div>
                        <v-sheet
                            class="tw-border tw-px-4 bg-gray-800 tw-rounded-xl py-4"
                            color="#f8f8f8"
                        >
                          <p class=" tw-font-bold text-center">History Log</p>
                          <div class="tw-max-w-xl tw-mx-auto">
                            <div class="tw-grid tw-gap-2">
                              <div class="tw-flex tw-justify-between">
                                <span>สร้างเมื่อ:</span>
                                <span>{{ getThaiDate(openLog?.createdAt) }}</span>
                              </div>
                              <div class="tw-flex tw-justify-between">
                                <span>status:</span>
                                <span>{{ openLog?.status }}</span>
                              </div>

                              <div class="tw-flex tw-justify-between">
                                <span>message:</span>
                                <span>{{ openLog?.message }}</span>
                              </div>


                              <div class="tw-flex tw-justify-between">
                                <span>ยื่นแบบแสดงรายการโดย:</span>
                                <span>{{ openLog?.taxReturnFilingOfBusiness }}</span>
                              </div>

                              <div class="tw-flex tw-justify-between">
                                <span>สถานะการยื่นแบบแสดงรายการ:</span>
                                <span>{{ openLog?.taxFilingStatus }}</span>
                              </div>

                              <div class="tw-flex tw-justify-between">
                                <span>ภายในกำหนดเวลา: </span>
                                <span>{{openLog?.chkIntime == 1}}</span>
                              </div>

                              <div class="tw-flex tw-justify-between">
                                <span>เกินกำหนดเวลา: </span>
                                <span>{{openLog?.chkOverdue == 1}}</span>
                              </div>

                              <div class="tw-flex tw-justify-between">
                                <span>เดือน-ปี:</span>
                                <span>{{ openLog?.taxPeriod }}</span>
                              </div>

                              <div class="tw-flex tw-justify-between">
                                <span>ภาษีขาย (Output Tax):</span>
                                <span>{{ openLog?.outputTax }}</span>
                              </div>

                              <div class="tw-flex tw-justify-between">
                                <span>ภาษีซื้อ (Input Tax):</span>
                                <span>{{ openLog?.["Input Tax"] }}</span>
                              </div>

                              <div class="tw-flex tw-justify-between">
                                <span>ภาษีมูลค่าเพิ่ม (Value Added Tax):</span>
                                <span>{{ openLog?.["Value Added Tax"]}}</span>
                              </div>

                              <div class="tw-flex tw-justify-between">
                                <span>ภาษีสุทธิ (Net Tax):</span>
                                <span>{{ openLog?.["Net Tax"]}}</span>
                              </div>

                              <div class="tw-flex tw-justify-between">
                                <span>เงินเพิ่ม (surcharge): </span>
                                <span>{{openLog?.["inCaseOfLateFilingAndPaymentOrAdditionalFiling"]}} </span>
                              </div>
                            </div>
                            <v-btn
                                block
                                color="primary"
                                elevation="0"
                                class="tw-mt-2"
                                :disabled="openLog?.percentage != 100"
                                @click="pdfSrc = openLog?.linkPdf, pdfDialog = true"
                            >
                              <v-icon class="tw-mr-2">mdi-eye</v-icon>
                              view PDF file</v-btn>
                          </div>
                        </v-sheet>
                      </div>
                    </v-card>
          </v-dialog>

          <v-divider class="tw-my-5"></v-divider>


          <!-- {{  valueAddedTaxReturnEachBranch}} -->
          <v-row class="text-row">
            <v-col cols="12">
              <p
                  style="
                  font-weight: bold;
                  margin-top: 5px;
                  margin-bottom: -15px;
                  
                "
              >
                ภาษีขาย (Output Tax)
              </p>
            </v-col>
          </v-row>
          <v-row class="text-row">
            <v-col class="d-flex flex-column align-start" cols="5">
              <div class="label-text">1. ยอดขายในเดือนนี้</div>
              <div style="margin-top: -1px; font-size: 14px; ">
                หรือกรณียื่นเพิ่มเติม
              </div>
            </v-col>
            <v-col cols="2">
              <v-text-field
                  :value="
                  displayAmount(valueAddedTaxReturn.L1SalesAmountThisMonth)
                "
                  class="text-field-style align-right"
                  dense
                  disabled
                  hide-details
                  outlined
                  placeholder="0.00"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row style="margin-top: -30px" align="center">
            <v-col cols="3">
              <v-checkbox
                  v-model="L1Checkbox"
                  :disabled="filterFetchData.submitStatus === 'ยื่นปกติ'"
                  dense
                  hide-details
                  style="margin-left: 0px"
                  value="1.1"
              >
              <template v-slot:label>
                  <span :style="{ marginTop: '4px', color: filterFetchData.submitStatus === 'ยื่นปกติ' ? 'rgba(0,0,0,0.38)' : 'black' }">(1.1) ยอดขายแจ้งไว้ขาด</span>
                  </template>
            </v-checkbox>
            </v-col>
            <v-col cols="2">
              <v-text-field
                  v-if="L1Checkbox === '1.1'"
                  :value="L1_1Amount"
                  class="text-field-style align-right"
                  dense
                  hide-details
                  outlined
                  placeholder="0.00"
                  :disabled="filterFetchData.submitStatus !== 'ยื่นปกติ'"
                  @input="L1_1Amount = $event"
                  @blur="L1_1Amount = formatAmount(L1_1Amount)"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row style="margin-top: -30px" align="center">
            <v-col cols="3">
              <v-checkbox
                  v-model="L1Checkbox"
                  :disabled="filterFetchData.submitStatus === 'ยื่นปกติ'"
                  dense
                  hide-details
                  style="margin-left: 0px"
                  value="1.2"
              >
              <template v-slot:label>
                  <span :style="{ marginTop: '4px', color: filterFetchData.submitStatus === 'ยื่นปกติ' ? 'rgba(0,0,0,0.38)' : 'black' }">(1.2) ยอดซื้อแจ้งไว้เกิน</span>
                  </template>
            </v-checkbox>
            </v-col>
            <v-col cols="2">
              <v-text-field
                  v-if="L1Checkbox === '1.2'"
                  :value="L1_2Amount"
                  class="text-field-style align-right"
                  dense
                  hide-details
                  outlined
                  placeholder="0.00"
                  @input="L1_2Amount = $event"
                  @blur="L1_2Amount = formatAmount(L1_2Amount); valueAddedTaxReturn.L1SalesAmountThisMonth = parseFloat(L1_2Amount.replace(/,/g, '')) || 0; recalculateL4()"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="text-row" style="margin-top: -1px">
            <v-col class="d-flex flex-column align-start" cols="5">
              <div class="label-text">
                2. ลบ ยอดขายที่เสียภาษีในอัตราร้อยละ 0 (ถ้ามี)
              </div>
              <div style="margin-top: -1px; font-size: 14px; ">หรือกรณียื่นเพิ่มเติม</div>
            </v-col>
            <v-col cols="2">
              <v-text-field
                  :value="
                  displayAmount(
                    valueAddedTaxReturn.L2LessSalesSubjectToZeroTaxRate
                  )
                "
                  class="text-field-style align-right"
                  dense
                  :disabled='true'
                  hide-details
                  outlined
                  placeholder="0.00"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row style="margin-top: -30px" align="center">
            <v-col cols="3">
              <v-checkbox
                  v-model="L2Checkbox"
                  :disabled="filterFetchData.submitStatus === 'ยื่นปกติ' || (valueAddedTaxReturn.L2LessSalesSubjectToZeroTaxRate > 0 && L2Checkbox !== '2.1')"
                  dense
                  hide-details
                  style="margin-left: 0px"
                  value="2.1"
              >
              <template v-slot:label>
                  <span :style="{ marginTop: '4px', color: (filterFetchData.submitStatus === 'ยื่นปกติ' || (valueAddedTaxReturn.L2LessSalesSubjectToZeroTaxRate > 0 && L2Checkbox !== '2.1')) ? 'rgba(0,0,0,0.38)' : 'black' }">(2.1) แจ้งไว้เกิน</span>
                  </template>
            </v-checkbox>
            </v-col>
            <v-col cols="2">
              <v-text-field
                  v-if="L2Checkbox === '2.1'"
                  :value="L2_1Amount"
                  class="text-field-style align-right"
                  dense
                  hide-details
                  outlined
                  placeholder="0.00"
                  @input="L2_1Amount = $event"
                  @blur="L2_1Amount = formatAmount(L2_1Amount); valueAddedTaxReturn.L2LessSalesSubjectToZeroTaxRate = parseFloat(L2_1Amount.replace(/,/g, '')) || 0; recalculateL4()"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="text-row">
            <v-col class="d-flex flex-column align-start" cols="5">
              <div class="label-text">3. ลบ ยอดขายที่ได้รับยกเว้น (ถ้ามี)</div>
              <div style="margin-top: -1px; font-size: 14px; ">หรือกรณียื่นเพิ่มเติม</div>
            </v-col>
            <v-col cols="2">
              <v-text-field
                  :value="displayAmount(valueAddedTaxReturn.L3LessExemptedSales)"
                  class="text-field-style align-right"
                  dense
                  :disabled='true'
                  hide-details
                  outlined
                  placeholder="0.00"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row style="margin-top: -30px" align="center">
            <v-col cols="3">
              <v-checkbox
                  v-model="L3Checkbox"
                  :disabled="filterFetchData.submitStatus === 'ยื่นปกติ' || (valueAddedTaxReturn.L3LessExemptedSales > 0 && L3Checkbox !== '3.1')"
                  dense
                  hide-details
                  style="margin-left: 0px"
                  value="3.1"
              >
              <template v-slot:label>
                  <span :style="{ marginTop: '4px', color: (filterFetchData.submitStatus === 'ยื่นปกติ' || (valueAddedTaxReturn.L3LessExemptedSales > 0 && L3Checkbox !== '3.1')) ? 'rgba(0,0,0,0.38)' : 'black' }">(3.1) แจ้งไว้เกิน</span>
                  </template>
            </v-checkbox>
            </v-col>
            <v-col cols="2">
              <v-text-field
                  v-if="L3Checkbox === '3.1'"
                  :value="L3_1Amount"
                  class="text-field-style align-right"
                  dense
                  hide-details
                  outlined
                  placeholder="0.00"
                  @input="L3_1Amount = $event"
                  @blur="L3_1Amount = formatAmount(L3_1Amount); valueAddedTaxReturn.L3LessExemptedSales = parseFloat(L3_1Amount.replace(/,/g, '')) || 0; recalculateL4()"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="text-row">
            <v-col class="d-flex align-center" cols="5">
              <div class="label-text">
                4. ยอดขายที่ต้องเสียภาษี (1.- 2. - 3.)
              </div>
            </v-col>
            <v-col cols="2">
              <v-text-field
                  :value="displayAmount(valueAddedTaxReturn.L4TaxableSalesAmount)"
                  class="text-field-style align-right"
                  dense
                  :disabled='true'
                  hide-details
                  outlined
                  placeholder="0.00"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="text-row">
            <v-col class="d-flex align-center" cols="5">
              <div class="label-text">5. ภาษีขายเดือนนี้</div>
              <div class="label-text" style="margin-left: 8px; white-space: nowrap;">อัตราร้อยละ</div>
              <v-text-field
                  v-model="L5VatRate"
                  class="text-field-style vat-rate-input"
                  style="max-width: 120px; margin-left: 6px;"
                  dense
                  hide-details
                  hide-spin-buttons
                  outlined
                  placeholder="7"
                  type="number"
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-text-field
                  :value="displayAmount(valueAddedTaxReturn.L5OutputTax)"
                  class="text-field-style align-right"
                  dense
                  :disabled='true'
                  hide-details
                  outlined
                  placeholder="0.00"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="text-row">
            <v-col cols="12">
              <p
                  style="
                  font-weight: bold;
                  margin-top: 5px;
                  margin-bottom: -15px;
                  
                "
              >
                ภาษีซื้อ (Input Tax)
              </p>
            </v-col>
          </v-row>
          <v-row class="text-row">
            <v-col class="d-flex flex-column align-start" cols="5">
              <div class="label-text">6. ยอดซื้อที่มีสิทธินําภาษีซื้อ</div>
              <div style="margin-top: -1px; font-size: 14px;">หรือกรณียื่นเพิ่มเติม</div>
            </v-col>
            <v-col cols="2">
              <v-text-field
                  :value="
                  displayAmount(valueAddedTaxReturn.L6PurchaseAmountThisMonth)
                "
                  class="text-field-style align-right"
                  dense
                  :disabled='true'
                  hide-details
                  outlined
                  placeholder="0.00"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row style="margin-top: -30px" align="center">
            <v-col cols="3">
              <v-checkbox
                  v-model="L6Checkbox"
                  :disabled="filterFetchData.submitStatus === 'ยื่นปกติ'"
                  dense
                  hide-details
                  style="margin-left: 0px"
                  value="6.1"
              >
              <template v-slot:label>
                  <span :style="{ marginTop: '4px', color: filterFetchData.submitStatus === 'ยื่นปกติ' ? 'rgba(0,0,0,0.38)' : 'black' }">(6.1) ยอดซื้อแจ้งไว้ขาด</span>
                  </template>
            </v-checkbox>
            </v-col>
            <v-col cols="2">
              <v-text-field
                  v-if="L6Checkbox === '6.1'"
                  :value="L6_1Amount"
                  class="text-field-style align-right"
                  dense
                  hide-details
                  outlined
                  placeholder="0.00"
                  :disabled="filterFetchData.submitStatus !== 'ยื่นปกติ'"
                  @input="L6_1Amount = $event"
                  @blur="L6_1Amount = formatAmount(L6_1Amount); valueAddedTaxReturn.L6PurchaseAmountThisMonth = parseFloat(L6_1Amount.replace(/,/g, '')) || 0; recalculateL7()"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row style="margin-top: -30px" align="center">
            <v-col cols="3">
              <v-checkbox
                  v-model="L6Checkbox"
                  :disabled="filterFetchData.submitStatus === 'ยื่นปกติ'"
                  dense
                  hide-details
                  style="margin-left: 0px"
                  value="6.2"
              >
              <template v-slot:label>
                  <span :style="{ marginTop: '4px', color: filterFetchData.submitStatus === 'ยื่นปกติ' ? 'rgba(0,0,0,0.38)' : 'black' }">(6.2) ยอดขายแจ้งไว้เกิน</span>
                  </template>
            </v-checkbox>
            </v-col>
            <v-col cols="2">
              <v-text-field
                  v-if="L6Checkbox === '6.2'"
                  :value="L6_2Amount"
                  class="text-field-style align-right"
                  dense
                  hide-details
                  outlined
                  placeholder="0.00"
                  @input="L6_2Amount = $event"
                  @blur="L6_2Amount = formatAmount(L6_2Amount); valueAddedTaxReturn.L6PurchaseAmountThisMonth = parseFloat(L6_2Amount.replace(/,/g, '')) || 0; recalculateL7()"
              ></v-text-field>
            </v-col>
          </v-row>

          <!-- ภาษีซื้อเฉลี่ย (Average input VAT, apportioned) — shown only when 6.2 is selected.
               When ticked, the "อัตราร้อยละ" next to item 7 acts as the apportionment ratio
               (สัดส่วน 0-100%) and the standard 7% VAT is applied on top: L7 = L6 × ratio% × 7%. -->
          <v-row v-if="L6Checkbox === '6.2'" style="margin-top: -30px" align="center">
            <v-col cols="5">
              <v-checkbox
                  v-model="L6AvgCheckbox"
                  dense
                  hide-details
                  style="margin-left: 0px"
              >
                <template v-slot:label>
                  <span style="margin-top: 4px; color: black;">ภาษีซื้อเฉลี่ย (Average input VAT)</span>
                </template>
              </v-checkbox>
            </v-col>
          </v-row>

          <v-row class="text-row" style="margin-top: -10px">
            <v-col class="d-flex align-center" cols="5">
              <div class="label-text">
                7. ภาษีซื้อเดือนนี้ (ตามหลักฐานใบกํากับภาษีของยอดซื้อตาม 6.)
              </div>
              <div class="label-text" style="margin-left: 8px; white-space: nowrap;">อัตราร้อยละ</div>
              <v-text-field
                  v-model="L7VatRate"
                  class="text-field-style vat-rate-input"
                  style="max-width: 120px; margin-left: 6px;"
                  dense
                  hide-details
                  hide-spin-buttons
                  outlined
                  placeholder="7"
                  type="number"
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-text-field
                  :value="displayAmount(valueAddedTaxReturn.L7InputTax)"
                  class="text-field-style align-right"
                  dense
                  :disabled='true'
                  hide-details
                  outlined
                  placeholder="0.00"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="text-row">
            <v-col cols="12">
              <p
                  class="label-text"
                  style="
                  font-weight: bold;
                  margin-top: 5px;
                  margin-bottom: -15px;
                  
                "
              >
                ภาษีมูลค่าเพิ่ม (Value Added Tax)
              </p>
            </v-col>
          </v-row>
          <v-row class="text-row">
            <v-col cols="5">
              <div class="label-text">
                8. ภาษีที่ต้องชําระเดือนนี้ (ถ้า 5. มากกว่า 7.)
              </div>
            </v-col>
            <v-col cols="2">
              <v-text-field
                  :value="displayAmount(valueAddedTaxReturn.L8TaxPayable)"
                  class="text-field-style align-right"
                  dense
                  :disabled='true'
                  hide-details
                  outlined
                  placeholder="0.00"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="text-row">
            <v-col class="d-flex align-center" cols="5">
              <div class="label-text">
                9. ภาษีที่ชําระเกินเดือนนี้ (ถ้า 5. น้อยกว่า 7.)
              </div>
            </v-col>
            <v-col cols="2">
              <v-text-field
                  :value="displayAmount(valueAddedTaxReturn.L9ExcessTaxPayable)"
                  class="text-field-style align-right"
                  dense
                  :disabled='true'
                  hide-details
                  outlined
                  placeholder="0.00"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="text-row">
            <v-col class="d-flex align-center" cols="5">
              <div class="label-text">10. ภาษีที่ชําระเกินยกมา</div>
            </v-col>
            <v-col cols="2">
              <template>
                <v-text-field
                    ref="L10Input"
                    v-model="L10ExcessTaxPaymentCarried"
                    class="text-field-style align-right"
                    dense
                    hide-details
                    hide-spin-buttons
                    outlined
                    placeholder="0.00"
                    type="number"
                ></v-text-field>
              </template>
            </v-col>
          </v-row>

          <v-row class="text-row">
            <v-col cols="12">
              <p
                  class="label-text"
                  style="
                  font-weight: bold;
                  margin-top: 5px;
                  margin-bottom: -15px;
                  
                "
              >
                ภาษีสุทธิ (Net Tax)
              </p>
            </v-col>
          </v-row>
          <v-row class="text-row">
            <v-col cols="5">
              <v-checkbox
                  v-model="valueAddedTaxReturn.L11Checked"
                  dense
                  hide-details
                  :disabled='true'
              >
                <template v-slot:label>
                  <span class="tw-text-black" style="margin-top: 4px"
                  >11. ต้องชําระ (ถ้า 8. มากกว่า 10.)</span
                  >
                </template>
              </v-checkbox>
            </v-col>
            <v-col cols="2">
              <v-text-field
                  :value="displayAmount(valueAddedTaxReturn.L11NetTaxPayable)"
                  class="text-field-style align-right"
                  dense
                  :disabled='true'
                  hide-details
                  outlined
                  placeholder="0.00"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="text-row">
            <v-col class="d-flex align-center" cols="5">
              <v-checkbox
                  v-model="valueAddedTaxReturn.L12Checked"
                  dense
                  hide-details
                  :disabled='true'
              >
                <template v-slot:label>
                  <span class="tw-text-black" style="margin-top: 4px"
                  >12. ชําระเกิน ((ถ้า 10. มากกว่า 8.) หรือ (9. รวมกับ
                    10.))</span
                  >
                </template>
              </v-checkbox>
            </v-col>
            <v-col cols="2">
              <v-text-field
                  :value="
                  displayAmount(valueAddedTaxReturn.L12NetExcessTaxPayable)
                "
                  class="text-field-style align-right"
                  dense
                  :disabled='true'
                  hide-details
                  outlined
                  placeholder="0.00"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="text-row">
            <v-col cols="12">
              <p
                  class="label-text"
                  style="
                  font-weight: bold;
                  margin-top: 5px;
                  margin-bottom: 5px;
                  
                "
              >
                กรณียื่นแบบแสดงรายการและชําระภาษีเกินกําหนดเวลา
                หรือยื่นเพิ่มเติม (In case of late filing and payment , or
                additional filing)
              </p>
            </v-col>
          </v-row>

          <v-row class="text-row" style="margin-top: 5px">
            <v-col class="d-flex align-center" cols="5">
              <div class="label-text">13. เงินเพิ่ม</div>
            </v-col>
            <v-col cols="2">
              <template>
                <v-text-field
                    v-model="L13Surcharge"
                    class="text-field-style align-right"
                    dense
                    hide-details
                    hide-spin-buttons
                    outlined
                    placeholder="0.00"
                    type="number"
                ></v-text-field>
              </template>
            </v-col>
          </v-row>

          <v-row class="text-row">
            <v-col class="d-flex align-center" cols="5">
              <div class="label-text">14. เบี้ยปรับ</div>
            </v-col>
            <v-col cols="2">
              <v-text-field
                  v-model="L14Penalty"
                  class="text-field-style align-right"
                  dense
                  hide-details
                  hide-spin-buttons
                  outlined
                  placeholder="0.00"
                  type="number"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="text-row">
            <v-col class="d-flex align-center" cols="5">
              <div class="label-text">
                15. รวมภาษี เงินเพิ่ม และเบี้ยปรับที่ต้องชําระ ((11. + 13. +
                14.) หรือ (13. + 14. - 12.))
              </div>
            </v-col>
            <v-col cols="2">
              <v-text-field
                  :value="displayAmount(valueAddedTaxReturn.L15TotalTaxPayable)"
                  class="text-field-style align-right"
                  dense
                  :disabled='true'
                  hide-details
                  outlined
                  placeholder="0.00"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="text-row">
            <v-col class="d-flex align-center" cols="5">
              <div class="label-text">
                16. รวมภาษีที่ชําระเกิน หลังคํานวณเงินเพิ่มและเบี้ยปรับแล้ว (12.
                - 13. - 14.)
              </div>
            </v-col>
            <v-col cols="2">
              <v-text-field
                  :value="
                  displayAmount(valueAddedTaxReturn.L16TotalExcessTaxPayable)
                "
                  class="text-field-style align-right"
                  dense
                  :disabled='true'
                  hide-details
                  outlined
                  placeholder="0.00"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="7">
              <div class="tw-grid tw-grid-cols-2 tw-gap-3">
                <v-btn
                    :class="{ small: isSmallScreen }"
                    class="white--text"
                    color="primary"
                    @click="onClickPDF('1')"
                >
                  <v-icon left>mdi-printer</v-icon>
                  | แบบแสดงรายการภาษีมูลค่าเพิ่ม (PDF)

                </v-btn>
                <!-- </v-col>
      <v-col cols="auto"> -->
                <v-btn
                    :class="{ small: isSmallScreen }"
                    class="white--text"
                    color="primary"
                    @click="onClickReport()"
                >
                  <v-icon left>mdi-printer</v-icon>
                  | ใบแนบ ภ.พ.30

                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card>

        <v-snackbar
            v-model="snackbar"
            :color="snackbarColor"
            class="tw-text-center"
            timeout="2000"
            top
        >
          {{ snackbarText }}
        </v-snackbar>

<!--        <CircularProgress-->
<!--            ref="loadingSpinner"-->
<!--            :message="progress.message"-->
<!--            :percentage="progress.percentage"-->
<!--            :showTrigger="false"-->
<!--            :size=300-->
<!--            overlayPosition="bottom"-->
<!--            @visibility-change="onVisibilityChange"-->
<!--        />-->
      </v-container>
    </v-main>
    <v-main v-else>
      <div class="tw-flex tw-justify-center tw-mt-20">
        <!-- <v-progress-circular
          :size="30"
          color="primary"
          indeterminate
        ></v-progress-circular> -->
      </div>
    </v-main>
  </Admin>
</template>

<script>
import Admin from "@/components/admin/admin-main-template";
// import CircularProgress from '@/components/public/circular-progress.vue';
import fc from "@/firebaseConfig";
import isMobile from "../../libs/detectMobile";
import firebase from "firebase/app";
import "firebase/auth";
import {mapState} from "vuex";
import {getCurrentPeriodMonth} from "@/libs/getPerioid";

const _ = require("lodash");
const axios = require("axios");
const moment = require("moment");
export default {
  data() {
    return {
      isLoading: false,
      pdfDialog: false,
      pdfSrc: "",
      //
      snackbar: false,
      snackbarText: "",
      snackbarColor: "",

      submitTypeList: ["ยื่นรวม", "ยื่นแยก"],
      submitStatusList: [
        "ยื่นปกติ",
        "ยื่นเพิ่มเติมครั้งที่ 1",
        "ยื่นเพิ่มเติมครั้งที่ 2",
      ],
      hierarchicalPeriods: [],

      //
      filterFetchData: {
        submitType: "ยื่นรวม",
        selectBranchId: "",
        submitStatus: "ยื่นปกติ", // ยื่นปกติ, ยื่นเพิ่มเติมครั้งที่ 1, ยื่นเพิ่มเติมครั้งที่ 2
        additionalFilingStatus: "", // in_time, late_filing
        selectedPeriod: "",
        selectedTimePeriod: null,
      },
      isSmallScreen: false,

      L1Checkbox: "", // "1.1" or "1.2"
      L1OriginalSalesAmount: 0,
      L1_1Amount: "",
      L1_2Amount: "",
      L2Checkbox: "", // "2.1"
      L2_1Amount: "",
      L3Checkbox: "", // "3.1"
      L3_1Amount: "",
      L5VatRate: "7",
      L7VatRate: "7",
      L6OriginalPurchaseAmount: 0,
      L6Checkbox: "", // "6.1" or "6.2"
      L6_1Amount: "",
      L6_2Amount: "",
      L6AvgCheckbox: false, // ภาษีซื้อเฉลี่ย (Average input VAT, apportioned) — for 6.1 or 6.2
      L10ExcessTaxPaymentCarried: "0.00",
      L13Surcharge: "0.00",
      L14Penalty: "0.00",
      progress: {
        status: '',
        message: '',
        percentage: 0,
      },
      isGenerating: false,
      jobId: "",
      unsubscribeProgress: null,
      isPdfAlreadyGenerated: false,


      logsList: [],
      logsListUnsubscribe: null,
      openLog: null,
      logDialog: false
    };
  },
  name: "TaxReport",
  components: {
    Admin,
  },
  created() {
    this.getTaxWHBranch();
    this.fetchLog();
    this.fetchTimePeriodsFromFirestore();
  },

  computed: {
    ...mapState({
      selectedCompanyProductList: (state) =>
          state.companies.selectedCompanyProductList,
      isProductListLoading: (state) => state.companies.isProductListLoading,
      taxWHBranch: (state) => state.thaismartTax.taxWHBranch,
      valueAddedTaxReturn: (state) =>
          state.thaismartTaxDetail.valueAddedTaxReturn,
      valueAddedTaxReturnEachBranch: (state) =>
          state.thaismartTaxDetail.valueAddedTaxReturnEachBranch,
      // companyDetail:(state) =>state.companies.companyDetail
    }),
    isSubmitAll() {
      return this.filterFetchData.submitType === "ยื่นรวม";
    },
    isNewForm() {
      const timePeriod = this.filterFetchData.selectedTimePeriod;
      if (!timePeriod?.startDate) return true;
      const selectedSeconds = timePeriod.startDate.seconds;
      const cutoffSeconds = new Date(2026, 2, 1).getTime() / 1000; // Mar 1, 2026
      return selectedSeconds >= cutoffSeconds;
    },
    pdftaxTemplate() {
      return this.isNewForm
          ? "gs://sld-etax.appspot.com/NsPDF/pp30_2026.pdf"
          : "gs://sld-etax.appspot.com/NsPDF/tax.pdf";
    },
    reporttaxTemplate() {
      return this.isNewForm
          ? "gs://sld-etax.appspot.com/NsPDF/AttachPP30_2026.pdf"
          : "gs://sld-etax.appspot.com/NsPDF/attachment.pdf";
    },
  },
  watch: {
    filterFetchData: {
      handler: function (val, oldVal) {
        if (val.submitType === "ยื่นรวม") {
          this.filterFetchData.selectBranchId = "";
        }
        this.fetchLog()
      },
      deep: true,
    },
    L1Checkbox: {
      handler: function (val) {
        if (val === "1.1" && this.filterFetchData.submitStatus !== "ยื่นปกติ") {
          this.valueAddedTaxReturn.L1SalesAmountThisMonth = this.L1OriginalSalesAmount;
          this.L1_1Amount = this.displayAmount(this.L1OriginalSalesAmount);
          this.recalculateL4();
        } else {
          this.L1_1Amount = "";
        }
        this.L1_2Amount = "";
        if (val === "1.2") {
          this.valueAddedTaxReturn.L5OutputTax = 0;
          this.recalculateL8L9();
        }
      },
    },
    "filterFetchData.submitStatus": {
      handler: function () {
        this.resetAll();
      },
    },
    "filterFetchData.selectedPeriod": {
      handler: function () {
        this.resetAll();
      },
    },
    "filterFetchData.additionalFilingStatus": {
      handler: function () {
        this.recalculateL15L16();
      },
    },
    L2Checkbox: {
      handler: function (val) {
        if (val !== "2.1") {
          this.L2_1Amount = "";
          this.valueAddedTaxReturn.L2LessSalesSubjectToZeroTaxRate = 0;
          this.recalculateL4();
        }
        if (val === "2.1") {
          this.valueAddedTaxReturn.L5OutputTax = 0;
          this.recalculateL8L9();
        }
      },
    },
    L3Checkbox: {
      handler: function (val) {
        if (val !== "3.1") {
          this.L3_1Amount = "";
          this.valueAddedTaxReturn.L3LessExemptedSales = 0;
          this.recalculateL4();
        }
        if (val === "3.1") {
          this.valueAddedTaxReturn.L5OutputTax = 0;
          this.recalculateL8L9();
        }
      },
    },
    L5VatRate: {
      handler: function (val) {
        const rate = parseFloat(val) || 0;
        const l4 = parseFloat(String(this.valueAddedTaxReturn.L4TaxableSalesAmount)) || 0;
        this.valueAddedTaxReturn.L5OutputTax = parseFloat((l4 * rate / 100).toFixed(2));
        this.recalculateL8L9();
      },
    },
    L6Checkbox: {
      handler: function (val) {
        if (val === "6.1" && this.filterFetchData.submitStatus !== "ยื่นปกติ") {
          this.valueAddedTaxReturn.L6PurchaseAmountThisMonth = this.L6OriginalPurchaseAmount;
          this.L6_1Amount = this.displayAmount(this.L6OriginalPurchaseAmount);
          this.recalculateL7();
        } else {
          this.L6_1Amount = "";
        }
        this.L6_2Amount = "";
        if (val === "6.2") {
          this.valueAddedTaxReturn.L7InputTax = 0;
          this.recalculateL8L9();
        } else {
          // ภาษีซื้อเฉลี่ย applies only under 6.2 — clear it when leaving 6.2 so the avg formula
          // does not stay active while its checkbox is hidden.
          this.L6AvgCheckbox = false;
        }
      },
    },
    L7VatRate: {
      handler: function () {
        // Single source of truth — recalculateL7 applies the avg-apportionment formula when
        // L6AvgCheckbox is on, or the plain L6 × rate% otherwise.
        this.recalculateL7();
      },
    },
    L6AvgCheckbox: {
      handler: function (val) {
        // ภาษีซื้อเฉลี่ย: when ON the "อัตราร้อยละ" field next to item 7 becomes the apportionment
        // ratio (0-100% per RD). Clear the stale VAT-rate 7 so it is not reused as a ratio so the
        // user enters the real ratio; restore 7 (VAT rate) when OFF. Setting L7VatRate re-triggers
        // its watcher → recalculateL7; the explicit call covers the no-change case.
        if (val) {
          this.L7VatRate = "";
        } else {
          this.L7VatRate = "7";
        }
        this.recalculateL7();
      },
    },
    L10ExcessTaxPaymentCarried: {
      handler: function () {
        this.recalculateL11L12();
      },
    },
    L13Surcharge: {
      handler: function () {
        this.recalculateL15L16();
      },
    },
    L14Penalty: {
      handler: function () {
        this.recalculateL15L16();
      },
    },
    jobId: {
      handler: function () {
        if (this.jobId && this.isGenerating) {
          this.watchProgress();
        }
      },
    },
  },
  methods: {
    getThaiDate(timestamp) {
      if (!timestamp) return "N/A";
      moment.locale("th");

      const date = new Date(timestamp.seconds * 1000);

      // Format the date with Thai month and Buddhist year
      const formattedDate = moment(date).format("hh:mm DD/MM/YYYY");

      return formattedDate;
    },

    // onVisibilityChange(visible) {
    //   this.isGenerating = visible;
    // },

    getColorClass(item) {
      if (item.type === "quarter") {
        return "bg-quarter";
      } else if (item.type === "year") {
        return "";
      }
      return "";
    },

    updateScreenSize() {
      this.isSmallScreen = window.innerWidth < 600;
    },

    handleTimePeriodSelectionAndCloseMenu(item) {
      this.filterFetchData.selectedTimePeriod = item;
      this.filterFetchData.selectedPeriod = item.name;
      this.applyFilingDeadlineStatus(item);
      // this.handleSelection(item);
      this.$refs.selectMenu.blur();
    },

    // ภ.พ.30 e-filing deadline = วันที่ 23 ของเดือนถัดจากเดือนภาษี
    // ยื่นภายใน/ในวันที่ 23 -> ภายในกำหนดเวลา (within_time), เกินวันที่ 23 -> เกินกำหนดเวลา (late_filing)
    applyFilingDeadlineStatus(period) {
      if (!period?.startDate?.seconds) return;
      const start = new Date(period.startDate.seconds * 1000);
      const deadline = new Date(start.getFullYear(), start.getMonth() + 1, 23, 23, 59, 59, 999);
      this.filterFetchData.additionalFilingStatus =
          new Date() <= deadline ? "within_time" : "late_filing";
    },

    async onClickPDF(selectedTaxWHCode) {
      console.log("this is TaxWHCode :", selectedTaxWHCode);
      console.log("this is periods :", this.selectedPeriod);
      try {
        // this.$store.dispatch("setGlobalLoading", true);
        this.downloadPdfLoading = true;
        this.pdfSrc = null;
        // Block export when ภาษีซื้อเฉลี่ย is ticked but the apportionment ratio is blank/out of 0-100%.
        if (!this.validateAvgRatio()) { this.downloadPdfLoading = false; return; }
        console.log("selectedTaxWHCode", selectedTaxWHCode);
        // if (!['1', '2'].includes(selectedTaxWHCode)) {
        //   throw new Error("Invalid tax code selected");
        // }

        let data;
        if (["1", "2"].includes(selectedTaxWHCode)) {
          console.log("selectedStartDate", this.selectedStartDate);
          console.log("selectedEndDate", this.selectedEndDate);
          data = this.valueAddedTaxReturnEachBranch;
        }
        if (
            this.displayAmount(
                this.valueAddedTaxReturn.L1SalesAmountThisMonth
            ) === "0.00" &&
            this.displayAmount(
                this.valueAddedTaxReturn.L2LessSalesSubjectToZeroTaxRate
            ) === "0.00" &&
            this.displayAmount(this.valueAddedTaxReturn.L3LessExemptedSales) ===
            "0.00" &&
            this.displayAmount(this.valueAddedTaxReturn.L4TaxableSalesAmount) ===
            "0.00" &&
            this.displayAmount(this.valueAddedTaxReturn.L5OutputTax) === "0.00" &&
            this.displayAmount(
                this.valueAddedTaxReturn.L6PurchaseAmountThisMonth
            ) === "0.00" &&
            this.displayAmount(this.valueAddedTaxReturn.L7InputTax) === "0.00" &&
            this.displayAmount(this.valueAddedTaxReturn.L8TaxPayable) ===
            "0.00" &&
            this.displayAmount(this.valueAddedTaxReturn.L9ExcessTaxPayable) ===
            "0.00" &&
            this.displayAmount(this.L10ExcessTaxPaymentCarried) === "0.00" &&
            this.displayAmount(this.valueAddedTaxReturn.L11NetTaxPayable) ===
            "0.00" &&
            this.displayAmount(
                this.valueAddedTaxReturn.L12NetExcessTaxPayable
            ) === "0.00" &&
            this.displayAmount(this.L13Surcharge) === "0.00" &&
            this.displayAmount(this.L14Penalty) === "0.00" &&
            this.displayAmount(this.valueAddedTaxReturn.L15TotalTaxPayable) ===
            "0.00" &&
            this.displayAmount(
                this.valueAddedTaxReturn.L16TotalExcessTaxPayable
            ) === "0.00"
        ) {
          this.snackbar = true;
          this.snackbarColor = "#FFCA28";
          this.snackbarText = "ไม่พบข้อมูล";
          return;
        }

        let type =
            selectedTaxWHCode === "1" || selectedTaxWHCode === "2"
                ? selectedTaxWHCode
                : undefined;

        // this.initProgress()
        this.$store.dispatch("setGlobalLoading", true);
        const result = await this.updateWHIncomeTaxReturn(data, "1");
        /* 
          {
              "success": true,
              "linkPdf": "https://firebasestorage.googleapis.com/v0/b/sld-etax.appspot.com/o/%2FDTRnq2huePWrzlqVh3KxdHp6W383%2FCompanies%2FqCp8p3s5hafVuAOBmutT%2FSettingThaiSmartTax%2F%E0%B9%81%E0%B8%9A%E0%B8%9A%E0%B9%81%E0%B8%AA%E0%B8%94%E0%B8%87Tax.pdf?alt=media&token=DTRnq2huePWrzlqVh3KxdHp6W383",
              "downloadToken": "DTRnq2huePWrzlqVh3KxdHp6W383"
          }
          */
        const link = result?.linkPdf;
        if (result?.isGenerated) {
          this.progress = {
            message: "PDF already generated, displaying",
            percentage: 90,
            status: "completed"
          }
        }

        if (!link) {
          throw new Error("PDF link not found");
        }

        console.log("link:: ", link);

        if (!this.pdfDialog && link) {
          const response = await axios
              .get(link, {
                responseType: "arraybuffer",
              }).catch(console.error);

          let url = URL.createObjectURL(
              new Blob([response.data], {type: "application/pdf"})
          );

          if (isMobile()) {
            let a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = url;
            a.download = "wht" + new Date().getTime() + ".pdf";
            a.click();
            window.URL.revokeObjectURL(url);
          } else {
            this.pdfSrc = url;
            this.pdfDialog = true;
          }
          // this is where to open progress
        }
      } catch (error) {
        console.error("Error in onClickWHT:", error);
        this.snackbar = true;
        this.snackbarColor = "red";
        this.snackbarText = `${error.message}`;
      } finally {
        this.$store.dispatch("setGlobalLoading", false);
        // this.completeProgress()
        this.downloadPdfLoading = false;
        this.selectedPeriod = null;
        this.selectedStartDate = null;
        this.selectedEndDate = null;
      }
    },

    onClickReport: async function (selectedTaxWHCode) {
      try {
        this.$store.dispatch("setGlobalLoading", true);
        this.downloadPdfLoading = true;
        this.pdfSrc = null;
        // Block export when ภาษีซื้อเฉลี่ย is ticked but the apportionment ratio is blank/out of 0-100%.
        if (!this.validateAvgRatio()) { this.downloadPdfLoading = false; this.$store.dispatch("setGlobalLoading", false); return; }
        let data;
        if (["1", "2"].includes(selectedTaxWHCode)) {
          data = this.valueAddedTaxReturnEachBranch;
        }

        if (
            this.displayAmount(
                this.valueAddedTaxReturn.L1SalesAmountThisMonth
            ) === "0.00" &&
            this.displayAmount(
                this.valueAddedTaxReturn.L2LessSalesSubjectToZeroTaxRate
            ) === "0.00" &&
            this.displayAmount(this.valueAddedTaxReturn.L3LessExemptedSales) ===
            "0.00" &&
            this.displayAmount(this.valueAddedTaxReturn.L4TaxableSalesAmount) ===
            "0.00" &&
            this.displayAmount(this.valueAddedTaxReturn.L5OutputTax) === "0.00" &&
            this.displayAmount(
                this.valueAddedTaxReturn.L6PurchaseAmountThisMonth
            ) === "0.00" &&
            this.displayAmount(this.valueAddedTaxReturn.L7InputTax) === "0.00" &&
            this.displayAmount(this.valueAddedTaxReturn.L8TaxPayable) ===
            "0.00" &&
            this.displayAmount(this.valueAddedTaxReturn.L9ExcessTaxPayable) ===
            "0.00" &&
            this.displayAmount(this.L10ExcessTaxPaymentCarried) === "0.00" &&
            this.displayAmount(this.valueAddedTaxReturn.L11NetTaxPayable) ===
            "0.00" &&
            this.displayAmount(
                this.valueAddedTaxReturn.L12NetExcessTaxPayable
            ) === "0.00" &&
            this.displayAmount(this.L13Surcharge) === "0.00" &&
            this.displayAmount(this.L14Penalty) === "0.00" &&
            this.displayAmount(this.valueAddedTaxReturn.L15TotalTaxPayable) ===
            "0.00" &&
            this.displayAmount(
                this.valueAddedTaxReturn.L16TotalExcessTaxPayable
            ) === "0.00"
        ) {
          this.snackbar = true;
          this.snackbarColor = "#FFCA28";
          this.snackbarText = "ไม่พบข้อมูล";
          return;
        }

        let type =
            selectedTaxWHCode === "1" || selectedTaxWHCode === "2"
                ? selectedTaxWHCode
                : undefined;

        const result = await this.updateAttReport(data, "1");
        //console.log("🚀 ~ result:", result);

        // ใช้ pdfBase64 ถ้ามี (emulator) หรือ fallback ไป linkPdf (production)
        let url;
        if (result?.pdfBase64) {
          const byteCharacters = atob(result.pdfBase64);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          url = URL.createObjectURL(new Blob([byteArray], {type: "application/pdf"}));
        } else if (result?.linkPdf) {
          const response = await axios.get(result.linkPdf, { responseType: "arraybuffer" });
          url = URL.createObjectURL(new Blob([response.data], {type: "application/pdf"}));
        } else {
          throw new Error("PDF link not found");
        }

        this.downloadPdfLoading = false;
        if (!this.pdfDialog && url) {
          if (isMobile()) {
            let a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = url;
            a.download = "attach_pp30_" + new Date().getTime() + ".pdf";
            a.click();
            window.URL.revokeObjectURL(url);
          } else {
            this.pdfSrc = url;
            this.pdfDialog = true;
          }
        }
      } catch (error) {
        //console.error("Error in onClickWHT:", error);
        this.snackbar = true;
        this.snackbarColor = "red";
        this.snackbarText = `${error.message}`;
      } finally {
        this.downloadPdfLoading = false;
        this.selectedPeriod = null;
        this.selectedStartDate = null;
        this.selectedEndDate = null;
        this.$store.dispatch("setGlobalLoading", false);
      }
    },

    updateWHIncomeTaxReturn: async function (paramdata, type) {
      // if (!paramdata) {
      //   return;
      // }
      // get user token
      let token = await firebase
          .auth()
          .currentUser.getIdToken(/* forceRefresh */ false)
          .then(function(idToken){
            return idToken
          })

      const headers = {
        "Content-Type": "application/json",
        Authorization: "JWT " + token,
      };
      // console.log(paramdata);
      // console.log("taxWHBranch", this.taxWHBranch);
      // console.log("selectBranchId", this.filterFetchData.selectBranchId);
      let branchCode =
          this.filterFetchData.selectBranchId === ""
              ? "00000"
              : this.filterFetchData.selectBranchId;

      const companydetail = this.taxWHBranch?.branch?.find(
          (branch) => branch.code == branchCode
      );
      // console.log("companydetail", companydetail);
      // console.log('this is periode', Months);
      //  console.log("filterFetchData",this.filterFetchData)
      let data = {
        companyID: this.$route.params.companyId,
        type: type, // 1=WHT53 ,2=WHT3 , 3=ATT53 , 4=ATT3
        jobId: this.jobId,
        data: {
          valueAddedTaxReturnEachBranch: this.valueAddedTaxReturnEachBranch,
          items: [],
          companyDetail: {...companydetail},
          "@Pdftax": this.pdftaxTemplate,
          submitStatus: this.filterFetchData.submitStatus,
          submitType: this.filterFetchData.submitType,
          selectedPeriod: this.filterFetchData.selectedPeriod,
          additionalFilingStatus: this.filterFetchData.additionalFilingStatus,
          L1Checkbox: this.L1Checkbox,
          L1_1Amount: this.L1_1Amount,
          L1_2Amount: this.L1_2Amount,
          L2Checkbox: this.L2Checkbox,
          L2_1Amount: this.L2_1Amount,
          L3Checkbox: this.L3Checkbox,
          L3_1Amount: this.L3_1Amount,
          L6Checkbox: this.L6Checkbox,
          L6_1Amount: this.L6_1Amount,
          L6_2Amount: this.L6_2Amount,
          L11Checked: this.valueAddedTaxReturn.L11Checked,
          L12Checked: this.valueAddedTaxReturn.L12Checked,
          checkbox: {
            "fillingInTime": this.filterFetchData.additionalFilingStatus === "in_time" ? true : false,
            "fillingLate": this.filterFetchData.additionalFilingStatus === "late_filing" ? true : false,
            "neitherInTimeNorLate": this.filterFetchData.additionalFilingStatus === "" ? true : false,
            "L1.1": this.L1Checkbox === "1.1" ? true : false,
            "L1.2": this.L1Checkbox === "1.2" ? true : false,
            "neither1.1Nor1.2": this.L1Checkbox === "" ? true : false,
            "L2.1": this.L2Checkbox === "2.1" ? true : false,
            "neither2.1": this.L2Checkbox === "" ? true : false,
            "L3.1": this.L3Checkbox === "3.1" ? true : false,
            "neither3.1": this.L3Checkbox === "" ? true : false,
            "L6.1": this.L6Checkbox === "6.1" ? true : false,
            "L6.2": this.L6Checkbox === "6.2" ? true : false,
            "neither6.1Nor6.2": this.L6Checkbox === "" ? true : false,
          },
          L1SalesAmountThisMonth: this.displayAmount(
              this.valueAddedTaxReturn.L1SalesAmountThisMonth
          ),
          L2LessSalesSubjectToZeroTaxRate: this.displayAmount(
              this.valueAddedTaxReturn.L2LessSalesSubjectToZeroTaxRate
          ),
          L3LessExemptedSales: this.displayAmount(
              this.valueAddedTaxReturn.L3LessExemptedSales
          ),
          L4TaxableSalesAmount: this.displayAmount(
              this.valueAddedTaxReturn.L4TaxableSalesAmount
          ),
          L5OutputTax: this.displayAmount(this.valueAddedTaxReturn.L5OutputTax),
          L6PurchaseAmountThisMonth: this.displayAmount(
              this.valueAddedTaxReturn.L6PurchaseAmountThisMonth
          ),
          L7InputTax: this.displayAmount(this.valueAddedTaxReturn.L7InputTax),
          L8TaxPayable: this.displayAmount(
              this.valueAddedTaxReturn.L8TaxPayable
          ),
          L9ExcessTaxPayable: this.displayAmount(
              this.valueAddedTaxReturn.L9ExcessTaxPayable
          ),
          L10ExcessTaxPaymentCarried: this.displayAmount(
              this.L10ExcessTaxPaymentCarried
          ),
          L11NetTaxPayable: this.displayAmount(
              this.valueAddedTaxReturn.L11NetTaxPayable
          ),
          L12NetExcessTaxPayable: this.displayAmount(
              this.valueAddedTaxReturn.L12NetExcessTaxPayable
          ),
          L13Surcharge: this.displayAmount(this.L13Surcharge),
          L14Penalty: this.displayAmount(this.L14Penalty),
          L15TotalTaxPayable: this.displayAmount(
              this.valueAddedTaxReturn.L15TotalTaxPayable
          ),
          L16TotalExcessTaxPayable: this.displayAmount(
              this.valueAddedTaxReturn.L16TotalExcessTaxPayable
          ),
        },
      };
      // console.log("data", data);

        const promise = new Promise((resolve, reject) => {
        //const baseUrl = "http://localhost:5001/sld-etax/us-central1/";
        const baseUrl = fc.cloudFunctionUrl;
        const endpoint = "updateTaxIncomeReturn";

        axios.post(baseUrl + endpoint, data, {headers}).then(
            (response) => {
              if (response.status === 200) {
                resolve(response.data);
              }
            },
            (error) => {
              reject(error);
              console.log(error);
              this.$store.dispatch("setGlobalLoading", false);
              this.downloadPdfLoading = false;
            }
        );
      });
      return promise;
    },

    updateAttReport: async function (paramdata, type) {
      if (!paramdata && paramdata?.lenght < 0) {
        return;
      }

      // get user token
      let token = await firebase
          .auth()
          .currentUser.getIdToken(/* forceRefresh */ false)
          .then(function (idToken) {
            return idToken;
          });
      const headers = {
        "Content-Type": "application/json",
        Authorization: "JWT " + token,
      };
      let branchCode =
          this.filterFetchData.selectBranchId === ""
              ? "00000"
              : this.filterFetchData.selectBranchId;
      const companydetail = this.taxWHBranch?.branch?.find(
          (branch) => branch.code == branchCode
      );
      // console.log('this is periode', Months);
      //console.log(this.valueAddedTaxReturnEachBranch);


      let data = {
        companyID: this.$route.params.companyId,
        type: type, // 1=WHT53 ,2=WHT3 , 3=ATT53 , 4=ATT3
        // jobId: jobId,
        // companyDetail: {...companydetail },
        data: {
          items: this.valueAddedTaxReturnEachBranch.map(() => {
            return {
              submitStatus: this.filterFetchData.submitStatus,
              selectedPeriod: this.filterFetchData.selectedPeriod,
              L1SalesAmountThisMonth: this.displayAmount(
                  this.valueAddedTaxReturn.L1SalesAmountThisMonth
              ),
              L2LessSalesSubjectToZeroTaxRate: this.displayAmount(
                  this.valueAddedTaxReturn.L2LessSalesSubjectToZeroTaxRate
              ),
              L3LessExemptedSales: this.displayAmount(
                  this.valueAddedTaxReturn.L3LessExemptedSales
              ),
              L4TaxableSalesAmount: this.displayAmount(
                  this.valueAddedTaxReturn.L4TaxableSalesAmount
              ),
              L5OutputTax: this.displayAmount(this.valueAddedTaxReturn.L5OutputTax),
              L6PurchaseAmountThisMonth: this.displayAmount(
                  this.valueAddedTaxReturn.L6PurchaseAmountThisMonth
              ),
              L7InputTax: this.displayAmount(this.valueAddedTaxReturn.L7InputTax),
              L8TaxPayable: this.displayAmount(this.valueAddedTaxReturn.L8TaxPayable),
              L9ExcessTaxPayable: this.displayAmount(
                  this.valueAddedTaxReturn.L9ExcessTaxPayable
              ),
              L11NetTaxPayable: this.displayAmount(
                  this.valueAddedTaxReturn.L11NetTaxPayable
              ),
              L12NetExcessTaxPayable: this.displayAmount(
                  this.valueAddedTaxReturn.L12NetExcessTaxPayable
              ),
              companyDetail: {...companydetail},
            };
          }),
          selectedPeriod: this.filterFetchData.selectedPeriod,
          submitStatus: this.filterFetchData.submitStatus,
          companyDetail: {...companydetail },
          L1Checkbox: this.L1Checkbox,
          L1_1Amount: this.L1_1Amount,
          L1_2Amount: this.L1_2Amount,
          L2Checkbox: this.L2Checkbox,
          L2_1Amount: this.L2_1Amount,
          L3Checkbox: this.L3Checkbox,
          L3_1Amount: this.L3_1Amount,
          L6Checkbox: this.L6Checkbox,
          L6_1Amount: this.L6_1Amount,
          L6_2Amount: this.L6_2Amount,
          "@Reporttax": this.reporttaxTemplate,
        },
      };
      // console.log(data);

      const promise = new Promise((resolve, reject) => {
      //const baseUrl = "http://localhost:5001/sld-etax/us-central1/";
      const baseUrl = fc.cloudFunctionUrl;
        const endpoint = "updateReportTax";

        axios
            .post(
              baseUrl+endpoint,
                data,
                {headers}
            )
            .then(
                (response) => {
                  if (response.status === 200) {
                    resolve(response.data);
                  }
                },
                (error) => {
                  reject(error);
                  console.log(error);
                  this.$store.dispatch("setGlobalLoading", false);
                  this.downloadPdfLoading = false;
                }
            );
      });
      return promise;
    },

    async fetchTimePeriodsFromFirestore() {
      const companyId = this.$route.params.companyId;
      if (!companyId) return;

      try {
        const snapshot = await fc.companies
          .doc(companyId)
          .collection("SettingThaiSmartTax")
          .doc("taxTimePeriods")
          .collection("TimePeriods")
          .get();

        const periods = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));

        // Build hierarchical structure
        const years = periods
          .filter(p => p.type === "year")
          .sort((a, b) => {
            const yearA = parseInt(a.name.match(/\d+/)[0], 10);
            const yearB = parseInt(b.name.match(/\d+/)[0], 10);
            return yearB - yearA;
          });

        const quarters = periods
          .filter(p => p.type === "quarter")
          .sort((a, b) => {
            const qA = parseInt(a.name.match(/\d+/)[0], 10);
            const qB = parseInt(b.name.match(/\d+/)[0], 10);
            return qA - qB;
          });

        const months = periods
          .filter(p => p.type === "month")
          .sort((a, b) => {
            const mA = parseInt(a.id.match(/\d+/)[0], 10);
            const mB = parseInt(b.id.match(/\d+/)[0], 10);
            return mA - mB;
          });

        this.hierarchicalPeriods = years.flatMap(year => [
          { ...year, level: 0 },
          ...quarters
            .filter(q => q.parentIndex === year.id)
            .flatMap(quarter => [
              { ...quarter, level: 1 },
              ...months
                .filter(m => m.parentIndex === quarter.id)
                .map(m => ({ ...m, level: 2 })),
            ]),
        ]);

        // Set default to current period
        const currentPeriod = getCurrentPeriodMonth(this.hierarchicalPeriods);
        if (currentPeriod) {
          this.filterFetchData.selectedPeriod = currentPeriod.name;
          this.filterFetchData.selectedTimePeriod = currentPeriod;
          this.applyFilingDeadlineStatus(currentPeriod);
        }
      } catch (error) {
        console.error("Error fetching time periods from Firestore:", error);
      }
    },

    getTaxWHBranch: function () {
      let companyId = this.$route.params.companyId;
      if (companyId) {
        this.$store
            .dispatch("thaismartTax/fetchTaxWHBranch", {companyId: companyId})
            .then(() => {
              this.filterFetchData.selectedBranchId =
                  this.taxWHBranch?.branch[0].code || null;
            })
            .catch((error) => {
              console.error("Error fetching branches:", error);
            });
      }
    },

    calculatedValueAddedTaxReturn() {
      this.$store.dispatch("thaismartTaxDetail/calculateTaxAddedValueReturn", {
        L1Checkbox: this.L1Checkbox,
        L2Checkbox: this.L2Checkbox,
        L3Checkbox: this.L3Checkbox,
        L6Checkbox: this.L6Checkbox,
        L10ExcessTaxPaymentCarried: this.L10ExcessTaxPaymentCarried,
        L13Surcharge: this.L13Surcharge,
        L14Penalty: this.L14Penalty,
      });
    },
    async fetchTaxReport() {
      this.isLoading = true;
      await this.$store.dispatch("thaismartTaxDetail/fetchSubmitDocsList", {
        companyId: this.$route.params.companyId,
        submitPeriod: this.filterFetchData.selectedTimePeriod.name,
        branchId: this.filterFetchData.selectBranchId,
        submitStatus: this.filterFetchData.submitStatus,
      });
      this.L10ExcessTaxPaymentCarried = "0.00";
      this.L13Surcharge = "0.00";
      this.L14Penalty = "0.00";
      this.L1Checkbox = "";
      this.L1_1Amount = "";
      this.L1_2Amount = "";
      this.L2Checkbox = "";
      this.L2_1Amount = "";
      this.L3Checkbox = "";
      this.L3_1Amount = "";
      this.L5VatRate = "7";
      this.L7VatRate = "7";
      this.L6Checkbox = "";
      this.L6_1Amount = "";
      this.L6_2Amount = "";
      this.L6AvgCheckbox = false;
      this.calculatedValueAddedTaxReturn();
      this.recalculateL15L16();
      this.$nextTick(() => {
        this.L1OriginalSalesAmount = this.valueAddedTaxReturn.L1SalesAmountThisMonth;
        this.L6OriginalPurchaseAmount = this.valueAddedTaxReturn.L6PurchaseAmountThisMonth;
      });
      this.isLoading = false;
    },
    formatAmount(value) {
      const num = parseFloat(String(value).replace(/,/g, ''));
      if (isNaN(num)) return '';
      return num.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    displayAmount(amount) {
      if (typeof amount === "number") {
        return amount?.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })
      }
      return amount;
    },
    resetAll() {
      this.$store.commit("thaismartTaxDetail/resetValueAddedTaxReturn");
      this.L1Checkbox = "";
      this.L1_1Amount = "";
      this.L1_2Amount = "";
      this.L2Checkbox = "";
      this.L2_1Amount = "";
      this.L3Checkbox = "";
      this.L3_1Amount = "";
      this.L5VatRate = "7";
      this.L7VatRate = "7";
      this.L6Checkbox = "";
      this.L6_1Amount = "";
      this.L6_2Amount = "";
      this.L6AvgCheckbox = false;
      this.L10ExcessTaxPaymentCarried = "0.00";
      this.L13Surcharge = "0.00";
      this.L14Penalty = "0.00";
    },
    recalculateL8L9() {
      const l5 = parseFloat(String(this.valueAddedTaxReturn.L5OutputTax)) || 0;
      const l7 = parseFloat(String(this.valueAddedTaxReturn.L7InputTax)) || 0;
      this.valueAddedTaxReturn.L8TaxPayable = l5 > l7 ? parseFloat((l5 - l7).toFixed(2)) : 0;
      this.valueAddedTaxReturn.L9ExcessTaxPayable = l5 < l7 ? parseFloat((l7 - l5).toFixed(2)) : 0;
      this.recalculateL11L12();
    },
    recalculateL11L12() {
      const l8 = parseFloat(String(this.valueAddedTaxReturn.L8TaxPayable)) || 0;
      const l9 = parseFloat(String(this.valueAddedTaxReturn.L9ExcessTaxPayable)) || 0;
      const l10 = parseFloat(String(this.L10ExcessTaxPaymentCarried).replace(/,/g, '')) || 0;
      const l11Checked = l8 > l10;
      this.valueAddedTaxReturn.L11Checked = l11Checked;
      this.valueAddedTaxReturn.L11NetTaxPayable = l11Checked ? parseFloat((l8 - l10).toFixed(2)) : 0;
      this.valueAddedTaxReturn.L12Checked = !l11Checked;
      this.valueAddedTaxReturn.L12NetExcessTaxPayable = !l11Checked ? parseFloat((l9 + l10).toFixed(2)) : 0;
      this.recalculateL15L16();
    },
    recalculateL15L16() {
      // ยื่นภายในกำหนดเวลา = ไม่มีเงินเพิ่ม/เบี้ยปรับ บรรทัด 15/16 จึงเป็น 0.00
      if (this.filterFetchData.additionalFilingStatus === "within_time") {
        this.valueAddedTaxReturn.L15TotalTaxPayable = 0;
        this.valueAddedTaxReturn.L16TotalExcessTaxPayable = 0;
        return;
      }
      const l11 = parseFloat(String(this.valueAddedTaxReturn.L11NetTaxPayable)) || 0;
      const l12 = parseFloat(String(this.valueAddedTaxReturn.L12NetExcessTaxPayable)) || 0;
      const l13 = parseFloat(String(this.L13Surcharge).replace(/,/g, '')) || 0;
      const l14 = parseFloat(String(this.L14Penalty).replace(/,/g, '')) || 0;
      const l11Checked = this.valueAddedTaxReturn.L11Checked;
      // L15: รวมภาษี เงินเพิ่ม เบี้ยปรับที่ต้องชำระ (11 + 13 + 14) หรือ (13 + 14 - 12)
      if (l11Checked) {
        this.valueAddedTaxReturn.L15TotalTaxPayable = parseFloat((l11 + l13 + l14).toFixed(2));
        this.valueAddedTaxReturn.L16TotalExcessTaxPayable = 0;
      } else {
        const l15candidate = l13 + l14 - l12;
        this.valueAddedTaxReturn.L15TotalTaxPayable = l15candidate > 0 ? parseFloat(l15candidate.toFixed(2)) : 0;
        this.valueAddedTaxReturn.L16TotalExcessTaxPayable = l12 > l13 + l14
          ? parseFloat((l12 - l13 - l14).toFixed(2))
          : 0;
      }
    },
    recalculateL7() {
      const l6 = parseFloat(String(this.valueAddedTaxReturn.L6PurchaseAmountThisMonth)) || 0;
      const rate = parseFloat(this.L7VatRate) || 0;
      if (this.L6AvgCheckbox) {
        // ภาษีซื้อเฉลี่ย (apportioned): L7VatRate is the apportionment ratio (สัดส่วน 0-100%);
        // the standard 7% VAT is applied on top → L7 = L6 × ratio% × 7%. Clamp ratio to 0-100 per RD.
        let ratio = rate;
        if (ratio < 0) ratio = 0;
        if (ratio > 100) ratio = 100;
        this.valueAddedTaxReturn.L7InputTax = parseFloat((l6 * (ratio / 100) * (7 / 100)).toFixed(2));
      } else {
        this.valueAddedTaxReturn.L7InputTax = parseFloat((l6 * rate / 100).toFixed(2));
      }
      this.recalculateL8L9();
    },
    // Validate the ภาษีซื้อเฉลี่ย ratio before PDF generation: per RD it must be 0-100%.
    validateAvgRatio() {
      if (!this.L6AvgCheckbox) return true;
      const r = parseFloat(this.L7VatRate);
      if (this.L7VatRate === "" || this.L7VatRate === null || isNaN(r) || r < 0 || r > 100) {
        this.snackbar = true;
        this.snackbarColor = "#FFCA28";
        this.snackbarText = "กรุณากรอกสัดส่วนภาษีซื้อเฉลี่ย (0-100%) ในช่องอัตราร้อยละ ข้อ 7.";
        return false;
      }
      return true;
    },
    recalculateL4() {
      const l1 = parseFloat(String(this.valueAddedTaxReturn.L1SalesAmountThisMonth)) || 0;
      const l2 = parseFloat(String(this.valueAddedTaxReturn.L2LessSalesSubjectToZeroTaxRate)) || 0;
      const l3 = parseFloat(String(this.valueAddedTaxReturn.L3LessExemptedSales)) || 0;
      this.valueAddedTaxReturn.L4TaxableSalesAmount = l1 + l2 + l3;
      const rate = parseFloat(this.L5VatRate) || 0;
      this.valueAddedTaxReturn.L5OutputTax = parseFloat((this.valueAddedTaxReturn.L4TaxableSalesAmount * rate / 100).toFixed(2));
      this.recalculateL8L9();
    },
    onClickPP30() {
      this.calculatedValueAddedTaxReturn();
      console.log("onClickPP30", this.valueAddedTaxReturn); // contain all 16 fields and 2 checkbox(L1Checkbox, L6Checkbox)
    },
    onClickAttachPP30() {
      console.log("onClickAttachPP30");
    },
    async initProgress() {
      this.isGenerating = true;
      this.progress = {
        status: 'Started',
        message: '',
        percentage: 0,
      };

      this.$refs.loadingSpinner.show();
      this.jobId = window.crypto.randomUUID();
    },
    completeProgress(msg = '') {
      this.unsubscribeProgress();
      if (msg) {
        this.progress.message = msg;
      }
      this.isGenerating = false;
      this.progress = {
        status: 'completed',
        message: 'Completed',
        percentage: 100,
      };
      this.$refs.loadingSpinner.hide();
      this.jobId = '';
    },
    async watchProgress() {
      if (!this.filterFetchData.selectedTimePeriod) return;
      const period = this.filterFetchData.selectedTimePeriod.name.split(' ').join('');
      const companyID = this.$route.params.companyId; // Replace with actual company ID
      const docPath = `Companies/${companyID}/reportThaiSmartTax/valueAddedTaxReturnPDF/${period}/${this.jobId}`;
      if (this.unsubscribeProgress) {
        this.unsubscribeProgress();
      }
      console.log('watch log:', this.jobId);
      this.unsubscribeProgress = fc.db.doc(docPath).onSnapshot(
          (doc) => {
            if (doc.exists && !this.isPdfAlreadyGenerated) {
              const data = doc.data();
              this.progress = {
                status: data.status,
                message: data.message,
                percentage: data.percentage,
              };
            }
          },
          (error) => {
            console.error("Error fetching document:", error);
          }
      );
    },
    async fetchLog() {
      if (!this.filterFetchData.selectedTimePeriod) return;
      const period = this.filterFetchData.selectedTimePeriod.name.split(' ').join('');
      const companyID = this.$route.params.companyId; // Replace with actual company ID
      const logCol = await fc.db.collection(`Companies/${companyID}/reportThaiSmartTax/valueAddedTaxReturnPDF/${period}`).get();

      let logs = logCol.docs.map(doc => doc.data());

      logs = logs.filter(log => log.taxReturnFilingOfBusiness === this.filterFetchData.submitType);

      if (this.filterFetchData.additionalFilingStatus) {
        logs = logs.filter(log =>
            this.filterFetchData.additionalFilingStatus === "within_time" ? log.chkIntime === 1 : log.chkOverdue === 1
        );
      }

      if (this.filterFetchData.submitStatus) {
        logs = logs.filter(log => log.taxFilingStatus === this.filterFetchData.submitStatus);
      }

      if (this.filterFetchData.selectBranchId && this.filterFetchData.submitType === "ยื่นแยก") {
        logs = logs.filter(log => log.subsidiariesBranch === this.filterFetchData.selectBranchId);
      }

      logs.sort((a, b) => a.createdAt.seconds - b.createdAt.seconds);

      this.logsList = logs.map((log, index) => ({
        id: log.id,
        doc: log,
        index: index + 1,
      }));
    },
    openLogDetail(log) {
      this.openLog = log.doc
      this.logDialog = true
    },
  },
};
</script>

<style lang="css" scoped>
.span-w {
  width: 100px;
}
.vat-rate-input ::v-deep input {
  text-align: right !important;
}

.table-container {
  padding: 1rem;
}

table {
  width: 100%;
  table-layout: fixed;
}

.iframe {
  overflow: hidden !important;
  height: 100% !important;
  width: 60% !important;
  position: absolute !important;
  left: 20% !important;
  right: 10% !important;
  top: 0 !important;
}

.text-field-style {
  .v-input {
    text-align: right !important;
  }

  
}

.bg-quarter{
  background-color:#B2DFDB ;
}


.align-right >>> input {
  text-align: right;
  padding-top: 14px;
}
</style>
